import { fetch } from "@deere/scs-fetch";
import { URL_SURVEY_API } from '../utils/constEnvVariables'
import { CRS_SURVEY_CODES, CRS_SURVEY_TEMPLATES } from '../utils/surveyLiterals'


export const getRequestsInGroup = function (supplier, campaignId, accessToken) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }

    return fetch(`${URL_SURVEY_API}/surveys/external/suppliersgroup/${supplier}&${campaignId}`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export const createGroupDeclaration = function (campaignId, userId, suppliers, accessToken, isAuthMethodOkta) {
    let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext" : "surveys";
    const requestOptions = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? 
    {
        method: 'POST',
        body: JSON.stringify({
            supplierGroup: suppliers,
            campaignId: campaignId,
            userId: userId,
            isAuthMethodOkta:  isAuthMethodOkta !== undefined ? isAuthMethodOkta : false
        })
    }
    :
    {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${accessToken}`},
        body: JSON.stringify({
            supplierGroup: suppliers,
            campaignId: campaignId,
            userId: userId,
            isAuthMethodOkta:  isAuthMethodOkta !== undefined ? isAuthMethodOkta : false
        })
    };

    return fetch(`${URL_SURVEY_API}/${pathParam}/cm/declaration/group`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export const getCmResponseByAssignmentId = function (assignmentId, accessToken, isAuthMethodOkta) {
    let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext" : "surveys";
    const requestOptions = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? { method: 'GET' } : { method: 'GET', headers: { 'Authorization': `Bearer ${accessToken}` } } ;

    return fetch(`${URL_SURVEY_API}/${pathParam}/cm/response/${assignmentId}`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export const getCmResponseByResponseIdAndCurrentAssignmentId = function (responseId,currentAssignmentId, accessToken, isAuthMethodOkta) {
    let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext" : "surveys";
    const requestOptions = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? { method: 'GET' } : { method: 'GET', headers: { 'Authorization': `Bearer ${accessToken}` } };

    return fetch(`${URL_SURVEY_API}/${pathParam}/cm/response/details/${responseId}/${currentAssignmentId}`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export const deleteCmResponseByResponseId = function (responseId, accessToken, isNonDeere, isAuthMethodOkta) {
    let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext" : "surveys";
    const requestOptions = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? { method: 'DELETE' } : { method: 'DELETE', headers: { 'Authorization': `Bearer ${accessToken}` } };

    return fetch(`${URL_SURVEY_API}/${pathParam}/cm/response/${responseId}/${isNonDeere}`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export const removeAssignmentFromResponse = function (assignmentId, accessToken) {
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }

    return fetch(`${URL_SURVEY_API}/surveys/cm/response/remove/${assignmentId}`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}


export const submitCMResponse = function (request, accessToken, isAuthMethodOkta) {
    let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext" : "surveys";
    const requestOptions = 
        isAuthMethodOkta !== undefined && !isAuthMethodOkta 
        ? 
        { method: 'PATCH', body: JSON.stringify(request) }
        :
        { method: 'PATCH', headers: {'Authorization': `Bearer ${accessToken}`}, body: JSON.stringify(request) };

    return fetch(`${URL_SURVEY_API}/${pathParam}/cm/response`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export const getAllPartsRequestedByAssignment = function (assignmentId, accessToken, surveyCode, isNonDeere, templateType) {
    let url;
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }
    if (templateType && templateType === CRS_SURVEY_TEMPLATES.PART) {
        url = `${URL_SURVEY_API}/surveys/generic/assignment/${assignmentId}/part/${isNonDeere}`
    } else {
        switch (surveyCode) {
            case CRS_SURVEY_CODES.CM: {
                url = `${URL_SURVEY_API}/surveys/cm/assignment/${assignmentId}/part/${isNonDeere}`
            }
            break;
            case CRS_SURVEY_CODES.EM: {
                url = `${URL_SURVEY_API}/surveys/em/assignment/${assignmentId}/part`
            }
            break;
            case CRS_SURVEY_CODES.TPS: {
                url = `${URL_SURVEY_API}/surveys/tps/assignment/${assignmentId}/part`
            }
            break;
            case CRS_SURVEY_CODES.TPSMEX: {
                url = `${URL_SURVEY_API}/surveys/tpsmex/assignment/${assignmentId}/part`
            }
            break;
            case CRS_SURVEY_CODES.COO: {
                url = `${URL_SURVEY_API}/surveys/coo/assignment/${assignmentId}/part`
            }
            break;
            default :
            url = `${URL_SURVEY_API}/surveys/generic/assignment/${assignmentId}/part/${isNonDeere}`
          }
    }
    
    return fetch(url, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export const getAllPartsRequestedByAssignmentGroup = function (assignmentId, accessToken, surveyCode, isNonDeere, templateType, isAuthMethodOkta) {
    let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext" : "surveys";
    const requestOptions = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? {method: 'GET'} : {method: 'GET', headers: {'Authorization': `Bearer ${accessToken}`}};

    return fetch(`${URL_SURVEY_API}/${pathParam}/cm/group/${assignmentId}/part`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export const deleteCmPartFromGroup= function (currentAssignmentId, partId, accessToken){
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }
    return fetch(`${URL_SURVEY_API}/surveys/cm/response/part/${currentAssignmentId}/${partId}`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
    
}

export const removeRequestedPartFromAssignment = function(currentAssignmentId, surveyCode,partNumber, accessToken, templateType){
    let url;
    if (templateType === CRS_SURVEY_TEMPLATES.PART) {
        url = `${URL_SURVEY_API}/surveys/generic/assignment/${currentAssignmentId}/part/${partNumber}`
    } else {
    switch (surveyCode) {
        case CRS_SURVEY_CODES.CM: {
            url = `${URL_SURVEY_API}/surveys/cm/assignment/${currentAssignmentId}/part/${partNumber}`
        }
        break;
        case CRS_SURVEY_CODES.EM: {
            url = `${URL_SURVEY_API}/surveys/em/assignment/${currentAssignmentId}/part/${partNumber}`
        }
        break;
        case CRS_SURVEY_CODES.TPS: {
            url = `${URL_SURVEY_API}/surveys/tps/assignment/${currentAssignmentId}/part/${partNumber}`
        }
        break;
        case CRS_SURVEY_CODES.TPSMEX: {
            url = `${URL_SURVEY_API}/surveys/tpsmex/assignment/${currentAssignmentId}/part/${partNumber}`
        }
        break;
        case CRS_SURVEY_CODES.COO: {
            url = `${URL_SURVEY_API}/surveys/coo/assignment/${currentAssignmentId}/part/${partNumber}`
        }
        break;
        default :
        url = `${URL_SURVEY_API}/surveys/generic/assignment/${currentAssignmentId}/part/${partNumber}`
        }
    }
    
   const requestOptions = {
    method: 'DELETE',
     headers: {
        'Authorization': `Bearer ${accessToken}`,
    }
   }
   
   return fetch(url, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { 
            console.log(error)
            throw error });
}
